import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	error: {
		id: 'component-picker.error',
		defaultMessage: "We couldn't retrieve components",
		description:
			'Message showed in component picker when there is an error while loading options from server.',
	},
});
export default messages;
